/**
 * Interface for a resource
 */
export default interface IResource {
    /**
     * The date on which this resource was created or null if it's not created.
     */
    createdOn?: Date;
    /**
     * The id of the user that created the resource or null if it's not created.
     */
    createdBy?: number;
    /**
     * The date on which this resource was edited or null if it's not created.
     */
    modifiedOn?: Date;
    /**
     * The id of the user that last edited the resource or null if it's not created.
     */
    modifiedBy?: number;
}

export type { IResource };
